import { useAuth } from './auth-provider';
import type { User } from '../types/user';

interface UseUserReturn {
  user: User | null;
  isLoaded: boolean;
  isSignedIn: boolean;
}

export function useUser(): UseUserReturn {
  const { user, isLoaded, isSignedIn } = useAuth();
  return { user, isLoaded, isSignedIn };
}
